module.exports = __webpack_public_path__ + "static/media/background.c0ad20b0.png";